
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Form } from "@/components/ui/form"
import { ScrollArea } from "@/components/ui/scroll-area"
import { 
  UserNameFields, 
  UserLocationFields, 
  UserRoleFields, 
  UserPasswordField 
} from "@/components/users/UserFormFields"
import { UserFormActions } from "@/components/users/UserFormActions"
import { useUserForm } from "@/hooks/useUserForm"

type UserEditDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  userId: string | null
  onSuccess: () => void
}

export function UserEditDialog({ open, onOpenChange, userId, onSuccess }: UserEditDialogProps) {
  const { 
    form, 
    loading, 
    onSubmit, 
    states, 
    cities, 
    mayors, 
    selectedState, 
    setSelectedState, 
    isError 
  } = useUserForm(userId, onSuccess, onOpenChange)

  if (isError) {
    return null
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh]">
        <DialogHeader>
          <DialogTitle>Editar Usuário</DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-[calc(90vh-120px)]">
          <div className="p-1">
            <Form {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
                <UserNameFields form={form} />
                <UserLocationFields 
                  form={form} 
                  states={states || []} 
                  cities={cities || []} 
                  selectedState={selectedState} 
                  onStateChange={setSelectedState} 
                />
                <UserRoleFields form={form} mayors={mayors || []} />
                <UserPasswordField form={form} />
                <UserFormActions loading={loading} />
              </form>
            </Form>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}
